import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/app/App';
import * as serviceWorker from './serviceWorker';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'
import { UserContextProvider } from './components/auth/cognito/UserContext'
import {Auth} from 'aws-amplify'
import { Auth0Provider } from '@auth0/auth0-react';
import {CaseTokenProvider} from "./components/auth/auth0/CaseTokenProvider";
import history from "./components/app/history"
import {PublicClientApplication} from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';

const authenticateWith = process.env.REACT_APP_AUTHENTICATE_WITH;

const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const auth0OrgId = process.env.REACT_APP_AUTH0_ORG_ID;
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const auth0RedirectUri = window.location.origin

const entraClientId = "5ab01702-6917-4912-b93f-f664d3439fec"
const entraTenantId = "b1020514-5511-4a05-bdce-58ba94d1adfd"
const entraRedirectUri = window.location.origin

const msalConfig = {
    auth: {
        clientId: entraClientId,
        authority: "https://login.microsoftonline.com/"+ entraTenantId + "/v2.0",  //add /v2.0
        redirectUri: entraRedirectUri, // or your app's redirect URI
    },
    cache: {
        cacheLocation: "localStorage", // or sessionStorage
        storeAuthStateInCookie: false,
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

const onRedirectCallback = (appState) => {
    console.log ('Index.js onRedirectCallback appState=', appState)
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

const auth0ProviderConfig = {
    domain: auth0Domain,
    clientId: auth0ClientId,
    onRedirectCallback,
    authorizationParams: {
        redirect_uri: window.location.origin,
        audience: auth0Audience,
        organization: auth0OrgId
    },

    cacheLocation:"memory",
    useRefreshTokens: false
};

console.log ('index.js authenticateWith ', authenticateWith, 'auth0Domain=', auth0Domain, 'auth0ClientId=', auth0ClientId, 'auth0RedirectUri=', auth0RedirectUri)

if (authenticateWith ==='cognito') {

    console.log ('REACT_APP_COGNITO_DOMAIN=', process.env.REACT_APP_COGNITO_DOMAIN);
    console.log ('REACT_APP_COGNITO_REGION=', process.env.REACT_APP_COGNITO_REGION);
    console.log ('REACT_APP_COGNITO_USER_POOL_ID=', process.env.REACT_APP_COGNITO_USER_POOL_ID);
    console.log ('REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID=', process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID);

    const authConfig = {
        Auth: {
            region: process.env.REACT_APP_COGNITO_REGION,
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
            mandatorySignIn: false,
            oauth: {
                clientId: 'keycloak-oidc', //'oidc',
                domain: process.env.REACT_APP_COGNITO_DOMAIN,
                scope: ['openid', 'email', 'profile'], //'email, 'profile' needed too??

                redirectSignIn: window.location.origin,
                redirectSignOut: window.location.origin,
                //responseType: 'ALLOW_CUSTOM_AUTH', //code ??
                responseType: 'code',
                options: {AdvancedSecurityDataCollectionFlag: true}
            }

        }
    }
    console.log('index.js call Auth.configure with authConfig=', authConfig);
    Auth.configure(authConfig);
    console.log('index.js Auth.configure done')
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <I18nextProvider i18n={i18n} >
        {
            authenticateWith === 'cognito' ?
            <UserContextProvider><App tab="home" /></UserContextProvider> :
                authenticateWith === 'auth0' ?
                    <CaseTokenProvider>
                        <Auth0Provider{...auth0ProviderConfig}>
                            <App tab="home"/>
                        </Auth0Provider>
                     </CaseTokenProvider> :
                    authenticateWith === "entra" ?
                        <MsalProvider instance={msalInstance}>
                            <App  tab="home" />
                        </MsalProvider> :
                        <App tab="home" />
        }
    </I18nextProvider>
);

serviceWorker.unregister();
